import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PostCard } from "@/components/staff/PostCard";

const FILTERS = {
  review: { label: "Para revisar", statuses: ["generating", "pending", "missed", "failed"] },
  scheduled: { label: "Agendados", statuses: ["approved", "publishing"] },
  published: { label: "Publicados", statuses: ["published"] },
  rejected: { label: "Rejeitados", statuses: ["rejected"] },
};

export const PostList = ({ posts, reload }) => {
  const [tab, setTab] = useState("review");
  const visible = posts.filter((p) => FILTERS[tab].statuses.includes(p.status));

  return (
    <section data-testid="post-list">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-[#121314] border border-white/10 rounded-none h-auto p-1 flex-wrap">
          {Object.entries(FILTERS).map(([k, f]) => (
            <TabsTrigger key={k} value={k} data-testid={`posts-tab-${k}`}
              className="rounded-none dz-heading uppercase tracking-wider data-[state=active]:bg-[#c81e1e] data-[state=active]:text-white text-zinc-400">
              {f.label} ({posts.filter((p) => f.statuses.includes(p.status)).length})
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="mt-6 grid grid-cols-1 xl:grid-cols-2 gap-6">
        {visible.map((p) => <PostCard key={p.id} post={p} reload={reload} />)}
      </div>
      {!visible.length && (
        <p className="mt-10 text-sm text-zinc-500" data-testid="posts-empty">Nenhum post aqui ainda.</p>
      )}
    </section>
  );
};
